import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CSpinner,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CCol,
  CButton,
  CInputRadio,
  CLabel,
  CInput,
  CSelect,
  CBadge
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import { profileCreate } from "../../../../actions/profileActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "../users.css";

// "Tipo de aluno" (típico / neurodivergente) ainda não foi liberado para os
// clientes: com false o campo some da tela e não é obrigatório. Alunos já
// classificados não perdem a classificação — campo não tocado não vai no
// payload, e o backend mantém o que existe.
const TIPO_DE_ALUNO_LIBERADO = false;

// "Responsáveis vinculados" no cadastro do ALUNO, idem: com false o campo some
// e a lista não vai no payload, então os vínculos existentes ficam como estão.
// O vínculo continua sendo feito pelo cadastro do responsável.
const RESPONSAVEL_DO_ALUNO_LIBERADO = false;

class UserCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      loading: true,
      creating: false,
      roles: [],
      schools: [],
      regions: [],
      groups: [],
      selectedRoles: [],
      principal: null,
      isEditedUserTeacher: false,
      teacherClasses: null,
      name: null,
      email: null,
      username: null,
      phone: null,
      birthday: null,
      password: null,
      confirm_password: null,
      gender: null,
      submitButton: false,
      hasUnsavedChanges: false,
      // VÍNCULOS
      selectedStudents: [], // alunos vinculados (para responsável) - MULTI
      selectedParents: [], // responsável vinculado (para aluno) - SINGLE (objeto ou null)
      isParent: false, // role_id === 8
      isStudent: false, // role_id === 7

      // Listas de opções para os selects
      studentOptions: [], // alunos disponíveis (role 7)
      parentOptions: [], // responsáveis disponíveis (role 8)

      // CARACTERIZAÇÃO DO ALUNO (típico / neurodivergente)
      // null aqui é apenas o estado INICIAL da tela — "ainda não escolhido".
      // Foi obrigatório de 26/08/2026 a 04/11/2026; hoje é opcional e está
      // fora da tela (TIPO_DE_ALUNO_LIBERADO).
      studentType: null,
      // Marca se o usuário MEXEU no campo nesta sessão de edição.
      // Sem isto, o formulário enviaria student_type em todo salvamento — e um
      // aluno cuja classificação não coubesse na tela (por permissão, por
      // exemplo) seria silenciosamente desclassificado ao salvar o telefone.
      // Campo não tocado não entra no payload, e o backend preserva o que há.
      studentTypeTouched: false,
      selectedNeurodivergences: [], // [{ value, label, requires_note }]
      neurodivergenceNotes: {}, // { [id]: "descrição livre" }
      neurodivergenceOptions: [] // catálogo vindo do backend
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.validator = this.validator.bind(this);
    this.loadUsers = this.loadUsers.bind(this);
    this.updateProfileFlags = this.updateProfileFlags.bind(this);
    this.loadStudentOptions = this.loadStudentOptions.bind(this);
    this.loadParentOptions = this.loadParentOptions.bind(this);
    this.loadNeurodivergenceOptions =
      this.loadNeurodivergenceOptions.bind(this);
    this.handleStudentTypeChange = this.handleStudentTypeChange.bind(this);
    this.handleNeurodivergencesChange =
      this.handleNeurodivergencesChange.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }
    return true;
  }

  // ============================================================
  // BUSCA ASSÍNCRONA DE USUÁRIOS COM FILTRO POR NOME
  // ============================================================
  loadUsers(inputValue, callback, roleId, schoolId, groupId, regionId) {
    const payload = {
      role: roleId,
      school: schoolId,
      group: groupId,
      region: regionId
    };
    if (inputValue && inputValue.length >= 2) {
      payload.name = inputValue;
    }

    axios
      .post(`${URL.api}access/user/listUserFilter`, payload, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(response => {
        if (response.data.success) {
          const options = response.data.data.map(user => ({
            value: user.id,
            label: user.name
          }));
          callback(options);
        } else {
          callback([]);
        }
      })
      .catch(() => callback([]));
  }

  // ============================================================
  // CARREGA LISTA DE ALUNOS (para responsável)
  // ============================================================
  loadStudentOptions() {
    const parentRole = this.state.selectedRoles.find(
      r => Number(r.role_id) === 8
    );
    const schoolId = parentRole?.school_id
      ? Number(parentRole.school_id)
      : null;
    const groupId = parentRole?.group_id ? Number(parentRole.group_id) : null;
    const regionId = parentRole?.region_id
      ? Number(parentRole.region_id)
      : null;
    if (!schoolId) {
      this.setState({ studentOptions: [] });
      return;
    }
    this.loadUsers(
      "",
      options => {
        this.setState({ studentOptions: options });
      },
      7,
      schoolId,
      groupId,
      regionId
    );
  }

  // ============================================================
  // CARREGA LISTA DE RESPONSÁVEIS (para aluno)
  // ============================================================
  loadParentOptions() {
    const studentRole = this.state.selectedRoles.find(
      r => Number(r.role_id) === 7
    );
    const schoolId = studentRole?.school_id
      ? Number(studentRole.school_id)
      : null;
    const groupId = studentRole?.group_id ? Number(studentRole.group_id) : null;
    const regionId = studentRole?.region_id
      ? Number(studentRole.region_id)
      : null;
    if (!schoolId) {
      this.setState({ parentOptions: [] });
      return;
    }
    this.loadUsers(
      "",
      options => {
        this.setState({ parentOptions: options });
      },
      8,
      schoolId,
      groupId,
      regionId
    );
  }

  // ============================================================
  // ATUALIZA FLAGS isParent / isStudent E CARREGA OPÇÕES
  // ============================================================
  updateProfileFlags() {
    const selectedRoles = this.state.selectedRoles;
    const isParent = selectedRoles.some(role => Number(role.role_id) === 8);
    const isStudent = selectedRoles.some(role => Number(role.role_id) === 7);

    this.setState(
      prevState => ({
        isParent,
        isStudent,
        selectedStudents: isParent ? prevState.selectedStudents : [],
        selectedParents: isStudent ? prevState.selectedParents : [],
        // Deixou de ser aluno: a caracterização não se aplica e não pode seguir
        // no payload, ou o backend recusa (422) numa tela que parece correta.
        studentType: isStudent ? prevState.studentType : null,
        selectedNeurodivergences: isStudent
          ? prevState.selectedNeurodivergences
          : [],
        neurodivergenceNotes: isStudent ? prevState.neurodivergenceNotes : {}
      }),
      () => {
        if (this.state.isParent) {
          this.loadStudentOptions();
        }
        if (this.state.isStudent) {
          this.loadParentOptions();
        }
      }
    );
  }

  // ============================================================
  // CATÁLOGO DE NEURODIVERGÊNCIAS
  // ============================================================
  // Fora da cadeia de callbacks do componentDidMount de propósito: aquela cadeia
  // já tem cinco níveis de aninhamento, e o catálogo não é pré-requisito de nada
  // — chega quando chegar, e o bloco só aparece para aluno.
  loadNeurodivergenceOptions() {
    axios
      .get(`${URL.api}access/neurodivergence/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(response => {
        if (response.data.success) {
          this.setState({
            neurodivergenceOptions: response.data.data.map(item => ({
              value: item.id,
              label: item.name,
              requires_note: item.requires_note,
              // category + support_level sustentam a exclusão mútua entre níveis
              // do mesmo quadro — ver handleNeurodivergencesChange.
              category: item.category,
              support_level: item.support_level
            }))
          });
        }
      })
      .catch(err => {
        // Silencioso para o usuário, mas com rastro: sem o catálogo o select fica
        // vazio, e sem esta linha o motivo seria invisível para quem for depurar.
        console.warn(
          "Não foi possível carregar o catálogo de neurodivergências:",
          err.response?.status || err.message
        );
      });
  }

  // ============================================================
  // TROCA DE TIPO DE ALUNO
  // ============================================================
  // Voltar para "típico" precisa limpar a seleção: o backend recusa típico com
  // neurodivergências marcadas, e deixar o estado morto no formulário produziria
  // um 422 sem nada de errado visível na tela.
  // ============================================================
  // SELEÇÃO DE NEURODIVERGÊNCIAS
  // ============================================================
  // Níveis do mesmo quadro se excluem: TEA tem UM nível de suporte por vez
  // (DSM-5), então marcar o Nível 3 substitui o Nível 2 em vez de somar. Já
  // TEA com TDAH, ou dislexia com discalculia, são combinações legítimas e
  // continuam livres.
  //
  // O discriminador é `support_level`, e não o código "TEA": item com nível
  // preenchido é gradação de um mesmo diagnóstico. Assim a regra vale sozinha
  // se algum dia outro quadro ganhar níveis, sem `if` novo aqui.
  //
  // Substituir, e não bloquear, porque é o que a pessoa quis dizer: quem clica
  // no Nível 3 está corrigindo o nível, não pedindo os dois.
  handleNeurodivergencesChange(selected) {
    const escolhidas = selected || [];
    const anteriores = this.state.selectedNeurodivergences;

    const novo = escolhidas.find(
      item => !anteriores.some(anterior => anterior.value === item.value)
    );

    let resultado = escolhidas;

    if (novo && novo.support_level) {
      const substituido = anteriores.find(
        item =>
          item.value !== novo.value &&
          item.support_level &&
          item.category === novo.category
      );

      if (substituido) {
        resultado = escolhidas.filter(item => item.value !== substituido.value);
        toastr.info(
          "Nível substituído",
          `"${substituido.label}" foi trocado por "${novo.label}" — só é possível um nível por vez.`
        );
      }
    }

    // Descrição de item que saiu da seleção não deve continuar no state: ela
    // voltaria sozinha se a pessoa remarcasse o item, com um texto que ela já
    // tinha decidido descartar.
    const notas = {};
    resultado.forEach(item => {
      if (this.state.neurodivergenceNotes[item.value]) {
        notas[item.value] = this.state.neurodivergenceNotes[item.value];
      }
    });

    this.setState({
      selectedNeurodivergences: resultado,
      neurodivergenceNotes: notas,
      studentTypeTouched: true,
      hasUnsavedChanges: true
    });
  }

  handleStudentTypeChange(studentType) {
    this.setState(prevState => ({
      studentType,
      studentTypeTouched: true,
      hasUnsavedChanges: true,
      selectedNeurodivergences:
        studentType === "neurodivergent"
          ? prevState.selectedNeurodivergences
          : [],
      neurodivergenceNotes:
        studentType === "neurodivergent" ? prevState.neurodivergenceNotes : {}
    }));
  }

  // ============================================================
  // VALIDAÇÃO DA CARACTERIZAÇÃO
  // ============================================================
  // Espelha o que o backend recusa, para o usuário ver a mensagem no formulário
  // em vez de um 422 depois de enviar. O backend valida de novo — esta é a
  // conveniência, aquela é a garantia.
  //
  // Retorna true quando pode seguir.
  validateStudentCharacterization() {
    if (!this.state.isStudent) {
      return true;
    }

    // Deixou de ser obrigatório (04/11/2026): o campo saiu da tela até ser
    // liberado para os clientes (ver TIPO_DE_ALUNO_LIBERADO). Sem tipo
    // marcado, nada vai no payload e o backend mantém o que já existe.
    // if (this.state.studentType === null) {
    //   toastr.warning(
    //     "Atenção",
    //     "Informe o tipo do aluno: Típico ou Neurodivergente."
    //   );
    //   return false;
    // }

    if (this.state.studentType !== "neurodivergent") {
      return true;
    }

    if (this.state.selectedNeurodivergences.length === 0) {
      toastr.warning(
        "Atenção",
        "Marque ao menos uma neurodivergência para o aluno neurodivergente."
      );
      return false;
    }

    const semDescricao = this.state.selectedNeurodivergences.find(
      item =>
        item.requires_note &&
        !(this.state.neurodivergenceNotes[item.value] || "").trim()
    );

    if (semDescricao) {
      toastr.warning(
        "Atenção",
        `Descreva a neurodivergência em "${semDescricao.label}".`
      );
      return false;
    }

    return true;
  }

  // Monta o bloco para o payload, ou null quando não há o que enviar.
  //
  // Devolver null importa tanto quanto devolver o objeto: sem tipo marcado, o
  // assunto não entra no payload, e o backend trata chave ausente como "não
  // mexa" — é o que impede o cadastro de apagar caracterização já existente ao
  // editar, por exemplo, só o telefone.
  buildStudentCharacterizationPayload() {
    // Não é aluno, ou ninguém mexeu no campo: o assunto não entra no payload, e
    // o backend trata chave ausente como "não mexa". É o que impede uma edição
    // de telefone de apagar classificação alheia.
    if (!this.state.isStudent || !this.state.studentTypeTouched) {
      return null;
    }

    // studentType null aqui é DELIBERADO — o usuário escolheu "Não informado",
    // e o backend entende chave-presente-com-null como "desclassifique".
    return {
      student_type: this.state.studentType,
      neurodivergences:
        this.state.studentType === "neurodivergent"
          ? this.state.selectedNeurodivergences.map(item => ({
              id: item.value,
              note: this.state.neurodivergenceNotes[item.value] || null
            }))
          : []
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ creating: true });
    const { id } = this.props.match.params;
    this.loadNeurodivergenceOptions();
    this.setState(
      () => ({ loading: true }),
      () => {
        axios
          .get(`${URL.api}access/role/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            respRole => {
              axios
                .get(`${URL.api}access/region/list`, {
                  headers: { authorization: `Bearer ${this.props.user.token}` }
                })
                .then(
                  respRegion => {
                    axios
                      .get(`${URL.api}access/group/list`, {
                        headers: {
                          authorization: `Bearer ${this.props.user.token}`
                        }
                      })
                      .then(
                        respGroup => {
                          axios
                            .get(`${URL.api}access/school/list`, {
                              headers: {
                                authorization: `Bearer ${this.props.user.token}`
                              }
                            })
                            .then(
                              respSchool => {
                                const roles = [
                                  "G",
                                  "U",
                                  "R",
                                  "E",
                                  "P",
                                  "A",
                                  "S",
                                  "V"
                                ];

                                if (
                                  (this.props.user.user_roles[0].group_id ===
                                    79 ||
                                    this.props.user.user_roles[0].group_id ===
                                      80 ||
                                    this.props.user.user_roles[0].group_id ===
                                      45) &&
                                  this.props.user.user_roles[0].role_id === 4
                                ) {
                                  respRole.data.data.splice(5, 1);
                                }

                                this.setState(
                                  () => ({
                                    roles: respRole.data.data
                                      .filter(role =>
                                        this.podeOferecerPerfil(role, roles)
                                      )
                                      .map(item => ({
                                        value: item.id,
                                        label: item.name,
                                        type: item.type
                                      })),
                                    groups: respGroup.data.data.map(item => ({
                                      value: item.id,
                                      label: item.name
                                    })),
                                    regions: respRegion.data.data.map(item => ({
                                      value: item.id,
                                      label: item.name,
                                      group_id: item.group_id
                                    })),
                                    schools: respSchool.data.data.map(item => ({
                                      value: item.id,
                                      label: item.name,
                                      region_id: item.region_id
                                    }))
                                  }),
                                  () => {
                                    if (!id) {
                                      this.setState(() => ({ loading: false }));
                                    } else {
                                      axios
                                        .get(
                                          `${URL.api}access/user/singleView/${id}`,
                                          {
                                            headers: {
                                              authorization: `Bearer ${this.props.user.token}`
                                            }
                                          }
                                        )
                                        .then(
                                          resp => {
                                            const userParent =
                                              resp.data.data.user_parent || [];

                                            // Alunos vinculados (MULTI)
                                            const selectedStudents = userParent
                                              .filter(item => item.student_id)
                                              .map(item => ({
                                                value: item.student_id,
                                                label:
                                                  item.student?.name ||
                                                  `Aluno ${item.student_id}`
                                              }));

                                            // Responsável vinculado (SINGLE)
                                            const selectedParents = userParent
                                              .filter(item => item.parent_id)
                                              .map(item => ({
                                                value: item.parent_id,
                                                label:
                                                  item.guardian?.name ||
                                                  `Responsável ${item.parent_id}`
                                              }));

                                            // Caracterização do aluno.
                                            // `?? null` e NUNCA `|| "typical"`:
                                            // o backend devolve null tanto para
                                            // "não informado" quanto para quem
                                            // não tem permissão de ver, e um
                                            // default aqui gravaria "típico" em
                                            // cima de qualquer um dos dois no
                                            // próximo salvamento.
                                            const userStudentType =
                                              resp.data.data.user_student_type
                                                ?.student_type ?? null;

                                            const userNeurodivergences =
                                              resp.data.data
                                                .user_neurodivergences || [];

                                            const selectedNeurodivergences =
                                              userNeurodivergences
                                                .filter(
                                                  item => item.neurodivergence
                                                )
                                                .map(item => ({
                                                  value:
                                                    item.neurodivergence.id,
                                                  label:
                                                    item.neurodivergence.name,
                                                  requires_note:
                                                    item.neurodivergence
                                                      .requires_note,
                                                  category:
                                                    item.neurodivergence
                                                      .category,
                                                  support_level:
                                                    item.neurodivergence
                                                      .support_level
                                                }));

                                            const neurodivergenceNotes = {};
                                            userNeurodivergences.forEach(
                                              item => {
                                                if (
                                                  item.neurodivergence &&
                                                  item.note
                                                ) {
                                                  neurodivergenceNotes[
                                                    item.neurodivergence.id
                                                  ] = item.note;
                                                }
                                              }
                                            );

                                            this.setState(
                                              () => ({
                                                name: resp.data.data.user.name,
                                                email:
                                                  resp.data.data.user.email,
                                                username:
                                                  resp.data.data.user.username,
                                                phone:
                                                  resp.data.data.user.phone,
                                                birthday:
                                                  resp.data.data.user_complement
                                                    ?.birthday || null,
                                                gender:
                                                  resp.data.data.user_complement
                                                    ?.gender || null,
                                                selectedRoles:
                                                  resp.data.data.user_role.map(
                                                    item => ({
                                                      role_id: item.role_id,
                                                      group_id: item.group_id,
                                                      region_id: item.region_id,
                                                      school_id: item.school_id,
                                                      role_type:
                                                        respRole.data.data.find(
                                                          role =>
                                                            role?.id ===
                                                            item?.role_id
                                                        )?.type
                                                    })
                                                  ),
                                                principal:
                                                  resp.data.data.user_role.findIndex(
                                                    item =>
                                                      item.principal === true
                                                  ),
                                                selectedStudents,
                                                selectedParents,
                                                isEditedUserTeacher:
                                                  resp.data.data.user_role.some(
                                                    item =>
                                                      Number(item.role_id) ===
                                                        6 &&
                                                      item.principal === true
                                                  ),
                                                teacherClasses:
                                                  resp.data.data
                                                    .teacher_classes || null,
                                                studentType: userStudentType,
                                                selectedNeurodivergences,
                                                neurodivergenceNotes
                                              }),
                                              () => {
                                                this.updateProfileFlags();
                                                this.loadStudentOptions();
                                                this.loadParentOptions();
                                                this.setState(() => ({
                                                  edit: true,
                                                  loading: false
                                                }));
                                              }
                                            );
                                          },
                                          error => {
                                            this.error(
                                              "Não foi possível obter informações do usuário"
                                            );
                                          }
                                        );
                                    }
                                  }
                                );
                              },
                              error => {
                                this.error(
                                  "Não foi possível listar as escolas"
                                );
                              }
                            );
                        },
                        error => {
                          this.error("Não foi possível listar os grupos");
                        }
                      );
                  },
                  error => {
                    this.error("Não foi possível listar os regionais");
                  }
                );
            },
            error => {
              this.error("Não foi possível listar os perfis");
            }
          );
      }
    );
  }

  enviar() {
    if (
      !this.state.username ||
      !this.state.email ||
      !this.state.name ||
      !this.state.password
    ) {
      toastr.warning("Atenção", "Preencha todos os campos obrigatórios");
      return;
    }

    if (this.state.password.length < 8) {
      toastr.warning("Atenção", "A senha deve conter ao menos 8 caracteres");
      return;
    }

    if (this.state.selectedRoles.length === 0) {
      toastr.warning("Atenção", "Escolha ao menos um perfil");
      return;
    }

    if (this.state.principal === null) {
      toastr.warning("Atenção", "Marque ao menos um perfil como principal");
      return;
    }

    if (this.state.password !== this.state.confirm_password) {
      toastr.warning("Atenção", "As senhas não coincidem");
      return;
    }

    // Validação para responsável (role 8)
    if (this.state.isParent && this.state.selectedStudents.length === 0) {
      toastr.warning(
        "Atenção",
        "É necessário vincular ao menos um aluno para um responsável."
      );
      return;
    }

    if (!this.validateStudentCharacterization()) {
      return;
    }

    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      principal: this.state.principal === index
    }));

    for (let i = 0; i < role.length; i++) {
      if (!role[i].role_id) {
        toastr.warning("Atenção", "Você precisa selecionar um perfil");
        return;
      }

      if (
        role[i].role_id === 2 &&
        role[i].group_id === null &&
        this.state.selectedRoles[i].role_type !== "V"
      ) {
        toastr.warning("Atenção", "Você precisa selecionar um grupo");
        return;
      }

      if (
        role[i].role_id === 3 &&
        role[i].region_id === null &&
        this.state.selectedRoles[i].role_type !== "V"
      ) {
        toastr.warning("Atenção", "Você precisa selecionar uma regional");
        return;
      }

      if (
        role[i].role_id >= 4 &&
        role[i].school_id === null &&
        this.state.selectedRoles[i].role_type !== "V"
      ) {
        toastr.warning("Atenção", "Você precisa selecionar uma escola");
        return;
      }
    }

    this.setState({ creating: true, submitButton: true });

    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      email: this.state.email,
      username: this.state.username,
      password: this.state.password,
      phone: this.state.phone,
      language_id: 1,
      expiration: 0,
      complement: {
        birthday: this.state.birthday,
        gender: this.state.gender,
        city: null,
        country: null
      },
      role
    };

    if (this.state.isParent) {
      obj.students = this.state.selectedStudents.map(item => item.value);
    }
    if (this.state.isStudent && RESPONSAVEL_DO_ALUNO_LIBERADO) {
      obj.parents = this.state.selectedParents.map(item => item.value);
    }

    const characterization = this.buildStudentCharacterizationPayload();
    if (characterization) {
      obj.student_type = characterization.student_type;
      obj.neurodivergences = characterization.neurodivergences;
    }

    try {
      axios
        .post(`${URL.api}access/user/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            toastr.success("Sucesso", "Usuário inserido com sucesso");
            this.setState({ hasUnsavedChanges: false }, () => {
              this.props.history.push("/userlist");
            });
          } else if (
            resp.data.error === "Já existe um usuário com esse login"
          ) {
            toastr.warning("Atenção", "Já existe um usuário com esse login");
          } else {
            this.error(resp.data.error || "Não foi possível inserir o usuário");
          }
        })
        .catch(err => {
          this.error(`Erro ao inserir: ${err.message}`);
        });
    } catch (err) {
      this.error(`Erro ao inserir: ${err.message}`);
    } finally {
      this.setState({ submitButton: false });
    }
  }

  atualizar() {
    if (!this.state.username || !this.state.email || !this.state.name) {
      toastr.warning("Atenção", "Preencha todos os campos obrigatórios");
      return;
    }

    if (this.state.selectedRoles.length === 0) {
      toastr.warning("Atenção", "Escolha ao menos um perfil");
      return;
    }

    if (this.state.principal === null) {
      toastr.warning("Atenção", "Marque ao menos um perfil como principal");
      return;
    }

    if (this.state.isParent && this.state.selectedStudents.length === 0) {
      toastr.warning(
        "Atenção",
        "É necessário vincular ao menos um aluno para um responsável."
      );
      return;
    }

    if (!this.validateStudentCharacterization()) {
      return;
    }

    this.setState({ submitButton: true });

    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      principal: this.state.principal === index
    }));

    for (let i = 0; i < role.length; i++) {
      if (!role[i].role_id) {
        toastr.warning("Atenção", "Você precisa selecionar um perfil");
        return;
      }

      if (role[i].role_id === 2 && role[i].group_id === null) {
        toastr.warning("Atenção", "Você precisa selecionar um grupo");
        return;
      }

      if (role[i].role_id === 3 && role[i].region_id === null) {
        toastr.warning("Atenção", "Você precisa selecionar uma regional");
        return;
      }

      if (role[i].role_id >= 4 && role[i].school_id === null) {
        toastr.warning("Atenção", "Você precisa selecionar uma escola");
        return;
      }
    }

    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      email: this.state.email,
      username: this.state.username,
      phone: this.state.phone,
      complement: {
        birthday: this.state.birthday,
        gender: this.state.gender,
        city: null,
        country: null
      },
      role
    };

    if (this.state.isParent) {
      obj.students = this.state.selectedStudents.map(item => item.value);
    }
    if (this.state.isStudent && RESPONSAVEL_DO_ALUNO_LIBERADO) {
      obj.parents = this.state.selectedParents.map(item => item.value);
    }

    const characterization = this.buildStudentCharacterizationPayload();
    if (characterization) {
      obj.student_type = characterization.student_type;
      obj.neurodivergences = characterization.neurodivergences;
    }

    axios
      .post(`${URL.api}access/user/update/${this.props.match.params.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              {
                creating: false,
                submitButton: false,
                hasUnsavedChanges: false
              },
              () => {
                this.props.history.push("/userlist");
              }
            );
          } else {
            this.error(resp.data.error || "Não foi possível editar o usuário");
            this.setState({ creating: false, submitButton: false });
          }
        },
        error => {
          this.error("Não foi possível editar o usuário");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  addRole() {
    this.setState(state => {
      const prev = [...state.selectedRoles];
      prev.push({
        role_id: null,
        group_id: this.props.general.active_roles.group_id,
        region_id: this.props.general.active_roles.region_id,
        school_id: this.props.general.active_roles.school_id,
        role_type: null
      });
      return { selectedRoles: prev };
    }, this.updateProfileFlags);
  }

  removeRole(index) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev.splice(index, 1);

      let { principal } = state;
      if (principal === index) {
        principal = null;
      } else if (principal > index) {
        principal -= 1;
      }

      return { selectedRoles: prev, principal };
    }, this.updateProfileFlags);
  }

  changeRole(index, value, type) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].role_id = Number(value);
      prev[index].role_type = type;
      return { selectedRoles: prev };
    }, this.updateProfileFlags);
  }

  changeGroup(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].group_id = value;
      prev[index].region_id = null;
      prev[index].school_id = null;
      return { selectedRoles: prev };
    }, this.updateProfileFlags);
  }

  changeRegion(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].region_id = value;
      prev[index].school_id = null;
      return { selectedRoles: prev };
    }, this.updateProfileFlags);
  }

  changeSchool(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].school_id = value;
      return { selectedRoles: prev };
    }, this.updateProfileFlags);
  }

  // O professor cadastra só estudantes e responsáveis, da escola dele (o
  // backend confere o mesmo em CadastroEscopoService). Os demais oferecem o
  // próprio nível para baixo; o Administrador Educandus, todos.
  podeOferecerPerfil(role, hierarchy) {
    const viewerType = this.props.general.active_roles.type;
    if (viewerType === "G") return true;
    if (viewerType === "P") return ["A", "S"].includes(role.type);
    return hierarchy.indexOf(role.type) >= hierarchy.indexOf(viewerType);
  }

  isViewerSuperiorToTeacher() {
    const hierarchy = ["G", "U", "R", "E", "P", "A", "S", "V"];
    const viewerType = this.props.general.active_roles.type;
    return hierarchy.indexOf(viewerType) < hierarchy.indexOf("P");
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/Userlist", to: "/Userlist" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard className="card-overflow">
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar usuário" : "Criar usuário"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o usuário selecionado"
                    : "Crie um novo usuário"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() =>
                  this.state.edit ? this.atualizar() : this.enviar()
                }
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody className="card-overflow">
              {/* CAMPOS DO USUÁRIO */}
              <CFormGroup>
                <CLabel>Nome</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-user"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.name}
                    onChange={e =>
                      this.setState({
                        name: e.target.value,
                        hasUnsavedChanges: true
                      })
                    }
                    placeholder="Digite o nome"
                  />
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>E-mail</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-envelope-o"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                    placeholder="Digite o e-mail"
                  />
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Login</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-id-card-o"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.username}
                    onChange={e => this.setState({ username: e.target.value })}
                    placeholder="Digite o login"
                  />
                </CInputGroup>
              </CFormGroup>

              {!this.state.edit && (
                <>
                  <CFormGroup>
                    <CLabel>Senha</CLabel>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-key"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="password"
                        value={this.state.password}
                        onChange={e =>
                          this.setState({ password: e.target.value })
                        }
                        placeholder="Digite a senha"
                      />
                    </CInputGroup>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Digite novamente sua senha</CLabel>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-key"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="password"
                        value={this.state.confirm_password}
                        onChange={e =>
                          this.setState({ confirm_password: e.target.value })
                        }
                        placeholder="Confirme a senha"
                      />
                    </CInputGroup>
                  </CFormGroup>
                </>
              )}

              <CFormGroup>
                <CLabel>Telefone (opcional)</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-phone"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="phone"
                    value={this.state.phone}
                    onChange={e => this.setState({ phone: e.target.value })}
                    placeholder="Digite o telefone"
                  />
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Data de nascimento (opcional)</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-calendar-o"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="date"
                    value={this.state.birthday}
                    onChange={e => this.setState({ birthday: e.target.value })}
                    max="2021-01-01"
                    min="1930-01-01"
                  />
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Gênero (opcional)</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-venus-mars"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    value={this.state.gender}
                    onChange={e => this.setState({ gender: e.target.value })}
                  >
                    <option>Escolha um gênero</option>
                    <option value="Masculino">Masculino</option>
                    <option value="Feminino">Feminino</option>
                  </CSelect>
                </CInputGroup>
              </CFormGroup>

              {/* ===== PERFIS ===== */}
              <CLabel className="d-block">Perfis</CLabel>
              {this.state.selectedRoles.map((item, index) => (
                <div
                  className="d-flex flex-column flex-lg-row w-100 mb-3 align-items-stretch align-items-lg-center"
                  key={index}
                >
                  <CRow
                    style={{ flex: 1, minWidth: 0 }}
                    className="mr-lg-3 w-100"
                  >
                    <CCol xs="12" sm="6" lg="3">
                      <CFormGroup className="m-0 mb-2 mb-lg-0">
                        <CInputGroup className="input-prepend">
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-user"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <Select
                            isSearchable
                            placeholder="Perfil"
                            name="Perfil"
                            options={this.state.roles}
                            classNamePrefix="select"
                            className="flex-1"
                            value={this.state.roles.find(
                              option => option.value === item.role_id
                            )}
                            defaultValue={this.state.roles.find(
                              option => option.value === item.role_id
                            )}
                            onChange={e =>
                              this.changeRole(index, e.value, e.type)
                            }
                          />
                        </CInputGroup>
                      </CFormGroup>
                    </CCol>
                    <CCol xs="12" sm="6" lg="3">
                      {["U", "R", "E", "P", "A", "S"].includes(
                        item.role_type
                      ) && (
                        <CFormGroup className="m-0 mb-2 mb-lg-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Grupo"
                              name="Grupo"
                              options={this.state.groups}
                              classNamePrefix="select"
                              className="flex-1"
                              value={
                                this.state.groups.find(
                                  option => option.value === item.group_id
                                ) || { value: null, label: "Grupo" }
                              }
                              defaultValue={this.state.groups.find(
                                option => option.value === item.group_id
                              )}
                              onChange={e => this.changeGroup(index, e.value)}
                              isDisabled={
                                this.props.general.active_roles.group_id !==
                                null
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      )}
                    </CCol>
                    <CCol xs="12" sm="6" lg="3">
                      {["R", "E", "P", "A", "S"].includes(item.role_type) && (
                        <CFormGroup className="m-0 mb-2 mb-lg-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Região"
                              name="Região"
                              options={this.state.regions.filter(
                                region => region.group_id === item.group_id
                              )}
                              classNamePrefix="select"
                              className="flex-1"
                              value={
                                this.state.regions.find(
                                  option => option.value === item.region_id
                                ) || { value: null, label: "Região" }
                              }
                              defaultValue={this.state.regions.find(
                                option => option.value === item.region_id
                              )}
                              onChange={e => this.changeRegion(index, e.value)}
                              isDisabled={
                                this.props.general.active_roles.region_id !==
                                null
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      )}
                    </CCol>
                    <CCol xs="12" sm="6" lg="3">
                      {["E", "P", "A", "S"].includes(item.role_type) && (
                        <CFormGroup className="m-0 mb-2 mb-lg-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Escola"
                              name="Escola"
                              options={this.state.schools.filter(
                                region => region.region_id === item.region_id
                              )}
                              classNamePrefix="select"
                              className="flex-1"
                              value={
                                this.state.schools.find(
                                  option => option.value === item.school_id
                                ) || { value: null, label: "Escola" }
                              }
                              defaultValue={this.state.schools.find(
                                option => option.value === item.school_id
                              )}
                              onChange={e => this.changeSchool(index, e.value)}
                              isDisabled={
                                this.props.general.active_roles.school_id !==
                                null
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      )}
                    </CCol>
                  </CRow>
                  <div className="d-flex align-items-center mt-2 mt-lg-0 ml-4 ml-lg-0">
                    <CFormGroup className="mb-0 mr-3">
                      <CInputRadio
                        className="form-check-input"
                        checked={this.state.principal === index}
                        onChange={() => this.setState({ principal: index })}
                      />
                      <CLabel className="m-0">Principal</CLabel>
                    </CFormGroup>
                    <CButton
                      variant="outline"
                      color="secondary"
                      className="text-dark"
                      onClick={() => this.removeRole(index)}
                    >
                      <i className="fa fa-trash"></i>
                    </CButton>
                  </div>
                </div>
              ))}
              <CButton
                variant="outline"
                color="secondary"
                className="text-dark"
                onClick={() => this.addRole()}
              >
                Adicionar um perfil
              </CButton>

              {this.state.edit &&
                this.state.isEditedUserTeacher &&
                this.isViewerSuperiorToTeacher() && (
                  <CFormGroup className="mt-4">
                    <CLabel className="d-block">
                      Turmas do professor{" "}
                      <CBadge color="primary" className="ml-1">
                        {this.state.teacherClasses
                          ? this.state.teacherClasses.rooms_count
                          : 0}
                      </CBadge>
                    </CLabel>
                    <div className="text-muted small mb-1">
                      Turmas em que o professor está vinculado:
                    </div>
                    <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                      {this.state.teacherClasses &&
                      this.state.teacherClasses.rooms.length > 0 ? (
                        this.state.teacherClasses.rooms.map(room => (
                          <CBadge
                            key={room.id}
                            color="info"
                            className="mr-1 mb-1"
                          >
                            {room.name}
                          </CBadge>
                        ))
                      ) : (
                        <CBadge color="secondary">
                          Nenhuma turma vinculada
                        </CBadge>
                      )}
                    </div>
                    <div className="text-muted small mb-1 mt-3">
                      Séries (anos escolares) atendidas pelas turmas acima:
                    </div>
                    <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                      {this.state.teacherClasses &&
                      this.state.teacherClasses.series.length > 0 ? (
                        this.state.teacherClasses.series.map(serie => (
                          <CBadge
                            key={serie.id}
                            color="warning"
                            className="mr-1 mb-1"
                          >
                            {serie.name}
                          </CBadge>
                        ))
                      ) : (
                        <CBadge color="secondary">
                          Nenhuma série vinculada
                        </CBadge>
                      )}
                    </div>
                  </CFormGroup>
                )}

              {/* ================================================================ */}
              {/* CAMPOS DE VÍNCULO – COM OPÇÕES GERENCIADAS PELO ESTADO             */}
              {/* ================================================================ */}

              {this.state.isParent && (
                <CFormGroup className="mt-4">
                  <CLabel>
                    Alunos vinculados <span className="text-danger">*</span>
                  </CLabel>
                  <CInputGroup className="input-prepend">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-users"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      isMulti
                      isSearchable
                      placeholder="Buscar alunos..."
                      noOptionsMessage={() => "Nenhum aluno encontrado"}
                      options={this.state.studentOptions}
                      value={this.state.selectedStudents}
                      onChange={selected => {
                        this.setState({
                          selectedStudents: selected || [],
                          hasUnsavedChanges: true
                        });
                      }}
                      styles={{
                        control: provided => ({
                          ...provided,
                          minHeight: "38px",
                          borderRadius: "0 0.25rem 0.25rem 0",
                          borderColor: "#d8dbe0"
                        }),
                        menu: provided => ({
                          ...provided,
                          zIndex: 999
                        })
                      }}
                    />
                  </CInputGroup>
                  <div className="text-muted small mt-1">
                    Selecione ao menos um aluno que este responsável irá
                    acompanhar.
                  </div>
                </CFormGroup>
              )}

              {/* DESLIGADO (04/11/2026), como o tipo de aluno: para voltar, pôr
                  RESPONSAVEL_DO_ALUNO_LIBERADO = true no topo do arquivo. */}
              {RESPONSAVEL_DO_ALUNO_LIBERADO && this.state.isStudent && (
                <CFormGroup className="mt-4">
                  {/* Opcional (04/11/2026): aluno pode ser salvo sem responsável. */}
                  <CLabel>Responsáveis vinculados</CLabel>
                  <CInputGroup className="input-prepend">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-user-circle"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      isMulti // <-- ADICIONE ISSO
                      isSearchable
                      placeholder="Buscar responsáveis..."
                      noOptionsMessage={() => "Nenhum responsável encontrado"}
                      options={this.state.parentOptions}
                      value={this.state.selectedParents} // agora deve ser um array
                      onChange={selected => {
                        this.setState({
                          selectedParents: selected || [], // sempre array, nunca null
                          hasUnsavedChanges: true
                        });
                      }}
                      styles={{
                        control: provided => ({
                          ...provided,
                          minHeight: "38px",
                          borderRadius: "0 0.25rem 0.25rem 0",
                          borderColor: "#d8dbe0"
                        }),
                        menu: provided => ({
                          ...provided,
                          zIndex: 999
                        })
                      }}
                    />
                  </CInputGroup>
                  <div className="text-muted small mt-1">
                    Opcional: selecione os responsáveis deste aluno, se houver.
                  </div>
                </CFormGroup>
              )}

              {/* ================================================================ */}
              {/* TIPO DE ALUNO — típico ou neurodivergente                          */}
              {/* ------------------------------------------------------------------ */}
              {/* Não confundir com PCD: aquele é enquadramento legal, tem laudo, e   */}
              {/* é preenchido no Acompanhamento Pedagógico. Este campo é             */}
              {/* caracterização pedagógica e não pede laudo nenhum.                  */}
              {/* Nenhuma opção vem marcada por padrão: sem marcação, o assunto não   */}
              {/* entra no payload e nada é gravado — "não informado" é um estado     */}
              {/* legítimo, e diferente de "típico".                                  */}
              {/* ================================================================ */}
              {/* DESLIGADO (04/11/2026): ainda não liberado para os clientes.
                  Para voltar, é só pôr TIPO_DE_ALUNO_LIBERADO = true no topo
                  do arquivo. */}
              {TIPO_DE_ALUNO_LIBERADO && this.state.isStudent && (
                <CFormGroup className="mt-4">
                  <CLabel>
                    Tipo de aluno <span className="text-danger">*</span>
                  </CLabel>

                  <div className="mb-2">
                    {/* Campo OBRIGATÓRIO por decisão de produto (26/08/2026):
                        todo aluno precisa ser classificado como Típico ou
                        Neurodivergente para que o cadastro possa ser salvo.

                        Não há opção "Não informado" na tela. Consequência a
                        conhecer: rádio não desmarca, então quem escolher errado
                        só corrige trocando para a outra opção — não há como
                        voltar ao estado sem classificação por aqui. O backend
                        ainda aceita `student_type: null` para desclassificar,
                        mas isso só é alcançável pela API. */}
                    <CFormGroup variant="custom-radio" inline>
                      <CInputRadio
                        custom
                        id="studentTypeTypical"
                        name="studentType"
                        checked={this.state.studentType === "typical"}
                        onChange={() => this.handleStudentTypeChange("typical")}
                      />
                      <CLabel
                        variant="custom-checkbox"
                        htmlFor="studentTypeTypical"
                      >
                        Típico
                      </CLabel>
                    </CFormGroup>

                    <CFormGroup variant="custom-radio" inline>
                      <CInputRadio
                        custom
                        id="studentTypeNeurodivergent"
                        name="studentType"
                        checked={this.state.studentType === "neurodivergent"}
                        onChange={() =>
                          this.handleStudentTypeChange("neurodivergent")
                        }
                      />
                      <CLabel
                        variant="custom-checkbox"
                        htmlFor="studentTypeNeurodivergent"
                      >
                        Neurodivergente
                      </CLabel>
                    </CFormGroup>
                  </div>

                  {this.state.studentType === null && (
                    <div className="text-danger small mb-2">
                      Obrigatório: escolha Típico ou Neurodivergente para salvar
                      o cadastro.
                    </div>
                  )}

                  {this.state.studentType === "neurodivergent" && (
                    <>
                      <CLabel className="mt-2">
                        Neurodivergências <span className="text-danger">*</span>
                      </CLabel>
                      <CInputGroup className="input-prepend">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-puzzle-piece"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <Select
                          isMulti
                          isSearchable
                          placeholder="Buscar neurodivergências..."
                          noOptionsMessage={() =>
                            "Nenhuma neurodivergência encontrada"
                          }
                          options={this.state.neurodivergenceOptions}
                          value={this.state.selectedNeurodivergences}
                          onChange={this.handleNeurodivergencesChange}
                          styles={{
                            control: provided => ({
                              ...provided,
                              minHeight: "38px",
                              borderRadius: "0 0.25rem 0.25rem 0",
                              borderColor: "#d8dbe0"
                            }),
                            menu: provided => ({
                              ...provided,
                              zIndex: 999
                            })
                          }}
                        />
                      </CInputGroup>
                      <div className="text-muted small mt-1">
                        Pode marcar mais de uma — combinações como TEA e TDAH
                        são comuns.
                      </div>

                      {/* Descrição livre, só nos itens que o catálogo marca como
                          requires_note (hoje, "Outra"). É campo aberto em dado
                          sensível: pede-se descrição pedagógica, não laudo. */}
                      {this.state.selectedNeurodivergences
                        .filter(item => item.requires_note)
                        .map(item => (
                          <CFormGroup className="mt-3" key={item.value}>
                            <CLabel>
                              Descrição — {item.label}{" "}
                              <span className="text-danger">*</span>
                            </CLabel>
                            <CInput
                              type="text"
                              maxLength={255}
                              placeholder="Como isso aparece em sala e que apoio o aluno precisa"
                              value={
                                this.state.neurodivergenceNotes[item.value] ||
                                ""
                              }
                              onChange={e => {
                                const valor = e.target.value;
                                this.setState(prevState => ({
                                  neurodivergenceNotes: {
                                    ...prevState.neurodivergenceNotes,
                                    [item.value]: valor
                                  },
                                  hasUnsavedChanges: true
                                }));
                              }}
                            />
                            <div className="text-muted small mt-1">
                              Descrição pedagógica. Não registre laudo, CID nem
                              histórico clínico aqui.
                            </div>
                          </CFormGroup>
                        ))}
                    </>
                  )}
                </CFormGroup>
              )}
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      profileCreate,
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCreate);
